<template>
  <div id="app" :class="['column', { centered: loading }]">
    <div v-if="loading" style="text-align: center">
      <font-awesome-icon icon="spinner" size="3x" pulse/>
      <p class="font-exo">Cargando...</p>
    </div>
    <template v-else-if="!loading && master">
      <Master :characters="characters" @detail="detailsOf"></Master>
    </template>
    <template v-else>
      <Modal v-if="modal.seen" @close="modal.seen = false" :info="modal.info"></Modal>
      <Detail :character="detail" @master="general" @modal="showModal" :network="network" :categories="categories"></Detail>
    </template>
  </div>
</template>

<script>
import Master from '@/components/Master'
import Detail from '@/components/detail/Detail'
import Modal from '@/components/Modal'

import axios from 'axios'
import MarkdownIt from 'markdown-it'

const md = MarkdownIt('commonmark')

export default {
  name: 'App',
  components: { Master, Detail, Modal },
  data () {
    return {
      loading: true,
      characters: [],
      master: true,
      detail: undefined,
      modal: {
        seen: false,
        info: {}
      },
      network: {
        nodes: [],
        edges: []
      },
      categories: {
        'Financiador': '#f44336',
        'Familiar': '#9c27b9',
        'Laboral': '#3f51b5',
        'Equipo UTL': '#009688',
        'Político': '#00bcd4',
        'Familiar y político': '#8bc34a',
        'Amistad': '#ffc107',
        'Cercanía': '#ff9800',
        'Empresarial': '#795548'
      }
    }
  },
  methods: {
    detailsOf (args) {
      this.detail = args
      this.master = false
    },
    general () {
      this.detail = undefined
      this.master = true
    },
    showModal (info) {
      this.modal.info = info
      this.modal.seen = true
    }
  },
  async created () {
    const response = await axios.get('https://script.google.com/macros/s/AKfycbyzvtmjTgrRcO0d44Wyyw3OETGL-fqZDmOtxk2UA45_1UHCoIdAIJYlt5ojETLssePO/exec')
    const { data } = response.data
    const nodes = []
    const characters = data.congresistas
      .filter(info => info['VERSION'] === 2)
      .map(info => {
        const sketch = `./static/sketches/${info['NOMBRE APP'].trim().toLowerCase().replace(/\s/g, '-')}.jpg`
        const id = typeof info['ID'] === 'string' ? info['ID'].trim() : info['ID']
        /* const sketch = `${info['NOMBRE APP'].trim().toLowerCase().replace(/\s/g, '-')}.png` */
        nodes.push({
          id,
          label: info['NOMBRE APP'].trim(),
          image: sketch,
          shape: 'circularImage',
          description: 'Congresista'
        })
        return {
          id,
          fullname: info['NOMBRE CONGRESISTA'].trim(),
          shortname: info['NOMBRE APP'].trim(),
          party: info['PARTIDO'].trim(),
          candidate: info['CANDIDATO A'].trim(),
          age: info['EDAD'].trim(),
          city: info['CIUDAD DE ORIGEN'].trim(),
          years: info['AÑOS EN EL CONGRESO'],
          income: {
            anual: info['SUELDO ANUAL BRUTO'],
            monthly: info['SUELDO MENSUAL']
          },
          jobs: info['OTROS CARGOS PÚBLICOS'].split('\n'),
          bio: info['BIOGRAFÍA'],
          sketch: sketch,
          assets: [
            {
              label: 'Casas',
              qty: info['CASAS'],
              description: md.render(info['CASAS HOVER']),
              icon: './static/robot.svg'
            },
            {
              label: 'Apartamentos',
              qty: info['APARTAMENTOS'],
              description: md.render(info['APARTAMENTOS HOVER']),
              icon: './static/robot.svg'
            },
            {
              label: 'Lotes',
              qty: info['LOTES'],
              description: md.render(info['LOTES HOVER']),
              icon: './static/robot.svg'
            },
            {
              label: 'Garajes',
              qty: info['GARAJES'],
              description: md.render(info['GARAJES HOVER']),
              icon: './static/robot.svg'
            },
            {
              label: 'Depósitos',
              qty: info['DEPÓSITO'],
              description: md.render(info['DEPÓSITO HOVER']),
              icon: './static/robot.svg'
            },
            {
              label: 'Fincas',
              qty: info['FINCA'],
              description: md.render(info['FINCA HOVER']),
              icon: './static/robot.svg'
            },
            {
              label: 'Empresas',
              qty: info['EMPRESAS'],
              description: md.render(info['EMPRESAS HOVER']),
              icon: './static/robot.svg'
            },
            {
              label: 'Locales',
              qty: info['MANZANA'].trim(),
              description: md.render(info['MANZANA HOVER']),
              icon: './static/robot.svg'
            },
            {
              label: 'Edificios',
              qty: info['EDIFICIO'] ? +info['EDIFICIO'] : 0,
              description: md.render(info['EDIFICIO HOVER']),
              icon: './static/robot.svg'
            },
            {
              label: 'Oficinas',
              qty: info['OFICINA'].trim(),
              description: md.render(info['OFICINA HOVER']),
              icon: './static/robot.svg'
            }
          ],
          taxes: {
            public: info['DECLARACIÓN DE RENTA PÚBLICA'].trim() !== 'NO',
            file: info['ARCHIVO RENTA'].split('|'),
            years: typeof info['AÑOS DE DECLARACIÓN DE RENTA'] === 'string' ? info['AÑOS DE DECLARACIÓN DE RENTA'].trim().split('_') : info['AÑOS DE DECLARACIÓN DE RENTA'],
            register: info['REGISTRO DE AÑO'],
            patrimony: info['PATRIMONIO LIBRE DE DEUDAS ÚLTIMO AÑO REPORTADO'],
            income: info['INGRESOS REPORTADOS ÚLTIMO AÑO REPORTADO'],
            pay: info['PAGO DE IMPUESTOS ÚLTIMO AÑO REPORTADO'],
            profit: info['GANANCIA POR TENER EMPRESAS'],
            disclaimer: info['DISCLAIMER']
          },
          impediment: {
            public: info['DECLARACIÓN DE IMPEDIMENTOS PÚBLICA'].trim() !== 'NO',
            file: info['ARCHIVO IMPUESTOS'].split('|'),
            years: typeof info['AÑO DE DECLARACIÓN DE IMPEDIMENTOS'] === 'string' ? info['AÑO DE DECLARACIÓN DE IMPEDIMENTOS'].split('_') : [info['AÑO DE DECLARACIÓN DE IMPEDIMENTOS']],
            description: info['Descripción'],
            info: []
          },
          legislate: {
            done: info['HA LEGISLADO SOBRE SUS  IMPEDIMENTOS'] !== 'NO',
            list: info['LISTA DE IMPEDIMENTOS'],
            description: info['DESCRIPCIÓN INCONSISTENCIA']
          },
          response: {
            deliver: info['ENTREGO RESPUESTA A CP'] !== 'NO',
            text: info['DESCRIPCIÓN RESPUESTA'],
            pdf: info['ARCHIVO RESPUESTA'].trim().split('|')
          }
        }
      })

    characters.map((character) => {
      if (character.impediment.public) {
        const temp = {}
        character.impediment.years.forEach((year, index) => {
          temp[year] = character.impediment.file[index]
        })
        character.impediment.info.push(temp)
      }
    })

    data['nodos_visualización'].filter(n => n['ID']).forEach(n => {
      const node = {
        id: typeof n['ID'] === 'string' ? n['ID'].trim() : n['ID'],
        label: n['NOMBRE CONEXIÓN A'].trim().replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()),
        shape: 'dot',
        color: this.categories[`${n['CATEGORÍA DE LA RELACIÓN'].trim()}`],
        size: 5,
        description: md.render(n['DESCRIPCIÓN'])
      }
      nodes.push(node)
    })

    const edges = data.ruta_del_dinero.map(e => ({
      from: typeof e['ID'] === 'string' ? e['ID'].trim() : e['ID'],
      to: e['ID_CONEXION'],
      label: e['TIPO DE RELACIÓN'],
      color: {
        color: this.categories[`${e['CATEGORÍA DE LA RELACIÓN'].trim()}`]
      }
    }))

    console.log(characters)

    this.network.nodes = nodes
    this.network.edges = edges
    this.characters = characters
    this.loading = false
  }
}
</script>

<style>
@import url('./css/index.css');

#app {
  height: 100%;
  position: relative;
  width: 100%;
}

@media only screen and (min-width: 576px) {
  #app {
    margin: 0 auto;
    width: 70%;
  }
}

@media only screen and (min-width: 992px) {
  #app {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue